'use strict';

function createNow() {
  return /* @__PURE__ */ new Date();
}

module.exports = createNow;
//# sourceMappingURL=createNow.cjs.map
